import { gql } from "@apollo/client";
import EmployerFields from "../fragments/employer-fragment";

export default gql`
  mutation UpdateEmployerProfileMutation($data: EmployerInput!) {
    unverifyEmployer(data: $data) {
      ...EmployerFields
    }
  }
  ${EmployerFields}
`;
